let wasm;

const cachedTextDecoder = (typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', { ignoreBOM: true, fatal: true }) : { decode: () => { throw Error('TextDecoder not available') } } );

if (typeof TextDecoder !== 'undefined') { cachedTextDecoder.decode(); };

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

let WASM_VECTOR_LEN = 0;

const cachedTextEncoder = (typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : { encode: () => { throw Error('TextEncoder not available') } } );

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}
/**
 * @param {string} text
 * @returns {Array<any>}
 */
export function parse(text) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse(ptr0, len0);
    return ret;
}

/**
 * @param {string} text
 * @param {Array<any>} math
 * @returns {Array<any>}
 */
export function parse_with_math(text, math) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parse_with_math(ptr0, len0, math);
    return ret;
}

/**
 * @param {string} text
 * @param {Array<any>} math
 * @returns {string}
 */
export function parse_to_json(text, math) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.parse_to_json(ptr0, len0, math);
        deferred2_0 = ret[0];
        deferred2_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * @param {string} text
 * @returns {boolean}
 */
export function validate_expression(text) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_expression(ptr0, len0);
    return ret !== 0;
}

/**
 * @param {string} text
 * @returns {Array<any>}
 */
export function tokenize_expression(text) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.tokenize_expression(ptr0, len0);
    return ret;
}

/**
 * @param {string} text
 * @returns {Array<any>}
 */
export function extract_expression_operands(text) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.extract_expression_operands(ptr0, len0);
    return ret;
}

/**
 * @param {string} text
 * @param {string} labels_string
 * @returns {boolean}
 */
export function evaluate_expression(text, labels_string) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(labels_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.evaluate_expression(ptr0, len0, ptr1, len1);
    return ret !== 0;
}

/**
 * @param {string} text
 * @returns {Array<any>}
 */
export function find_solution(text) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.find_solution(ptr0, len0);
    return ret;
}

/**
 * @param {string} text
 * @returns {boolean}
 */
export function is_valid_diff(text) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.is_valid_diff(ptr0, len0);
    return ret !== 0;
}

/**
 * @param {string} text
 * @returns {boolean}
 */
export function is_valid_json(text) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.is_valid_json(ptr0, len0);
    return ret !== 0;
}

/**
 * @param {string} text
 * @param {string} color_add
 * @param {string} color_del
 * @returns {string}
 */
export function colorize_diff(text, color_add, color_del) {
    let deferred4_0;
    let deferred4_1;
    try {
        const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(color_add, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(color_del, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.colorize_diff(ptr0, len0, ptr1, len1, ptr2, len2);
        deferred4_0 = ret[0];
        deferred4_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
}

/**
 * @param {string} expression
 * @returns {any}
 */
export function calculate(expression) {
    const ptr0 = passStringToWasm0(expression, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.calculate(ptr0, len0);
    return ret;
}

/**
 * Recommended sample size for encoding detection (8192 bytes).
 * Reading more than this provides no additional accuracy.
 * @returns {number}
 */
export function get_recommended_sample_size() {
    const ret = wasm.get_recommended_sample_size();
    return ret >>> 0;
}

/**
 * Safe sample size including padding for multi-byte sequences (8196 bytes).
 * Use this when reading from files to avoid truncating characters.
 * @returns {number}
 */
export function get_safe_sample_size() {
    const ret = wasm.get_safe_sample_size();
    return ret >>> 0;
}

/**
 * Minimum sample size for good confidence (512 bytes).
 * The function works with any size, but smaller samples may have lower confidence.
 * @returns {number}
 */
export function get_min_sample_size() {
    const ret = wasm.get_min_sample_size();
    return ret >>> 0;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}
/**
 * Detect encoding from a byte array.
 *
 * # Usage from JavaScript
 *
 * ```javascript
 * // For large files, only read the first 8KB:
 * const bytesToRead = Math.min(file.size, get_safe_sample_size());
 * const blob = file.slice(0, bytesToRead);
 * const buffer = await blob.arrayBuffer();
 * const bytes = new Uint8Array(buffer);
 * const result = detect_encoding_from_bytes(bytes);
 *
 * if (result.type === "binary") {
 *     console.log("Binary file detected");
 * } else if (result.type === "text") {
 *     console.log(`Text file: ${result.encoding} (confidence: ${result.confidence})`);
 * } else if (result.type === "possibly_text") {
 *     console.log(`Possibly text, candidates: ${result.candidates}`);
 * }
 * ```
 *
 * # Returns
 *
 * Returns a JavaScript object with one of these structures:
 *
 * - Binary file: `{ type: "binary" }`
 * - Text file: `{ type: "text", encoding: "UTF-8", confidence: 0.95 }`
 * - Ambiguous: `{ type: "possibly_text", candidates: [{encoding: "Shift-JIS", confidence: 0.7}, ...] }`
 * @param {Uint8Array} bytes
 * @returns {any}
 */
export function detect_encoding_from_bytes(bytes) {
    const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.detect_encoding_from_bytes(ptr0, len0);
    return ret;
}

/**
 * Detect encoding from a byte array with an optional hint (from HTTP headers, HTML meta, etc.).
 *
 * # Usage from JavaScript
 *
 * ```javascript
 * // With hint from HTTP Content-Type header
 * const contentType = response.headers.get('Content-Type');
 * const charset = extractCharset(contentType); // e.g., "utf-8", "shift-jis"
 * const result = detect_encoding_from_bytes_with_hint(bytes, charset);
 * ```
 * @param {Uint8Array} bytes
 * @param {string | undefined} [hint]
 * @returns {any}
 */
export function detect_encoding_from_bytes_with_hint(bytes, hint) {
    const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(hint) ? 0 : passStringToWasm0(hint, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ret = wasm.detect_encoding_from_bytes_with_hint(ptr0, len0, ptr1, len1);
    return ret;
}

/**
 * Validate CSV format and return row count and field count.
 *
 * # Usage from JavaScript
 *
 * ```javascript
 * const csvBytes = new TextEncoder().encode(csvText);
 * const result = validate_csv_format(csvBytes);
 *
 * if (result.error) {
 *     console.error(`CSV validation failed: ${result.error}`);
 * } else {
 *     console.log(`Valid CSV: ${result.rows} rows, ${result.fields} fields`);
 * }
 * ```
 *
 * # Returns
 *
 * Returns a JavaScript object with one of these structures:
 *
 * - Success: `{ rows: 100, fields: 5 }`
 * - Error: `{ error: "InvalidUtf8" }` or `{ error: "UnterminatedQuote" }` etc.
 * @param {Uint8Array} data
 * @returns {any}
 */
export function validate_csv_format(data) {
    const ptr0 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_csv_format(ptr0, len0);
    return ret;
}

/**
 * Validate CSV format from a string and return row count and field count.
 *
 * # Usage from JavaScript
 *
 * ```javascript
 * const csvText = `name,age,city
 * Alice,30,NYC
 * Bob,25,SF`;
 *
 * const result = validate_csv_format_str(csvText);
 *
 * if (result.error) {
 *     console.error(`CSV validation failed: ${result.error}`);
 * } else {
 *     console.log(`Valid CSV: ${result.rows} rows, ${result.fields} fields`);
 * }
 * ```
 *
 * # Returns
 *
 * Returns a JavaScript object with one of these structures:
 *
 * - Success: `{ rows: 100, fields: 5 }`
 * - Error: `{ error: "InvalidUtf8" }` or `{ error: "UnterminatedQuote" }` etc.
 * @param {string} text
 * @returns {any}
 */
export function validate_csv_format_str(text) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validate_csv_format_str(ptr0, len0);
    return ret;
}

/**
 * Extract a range of lines from text data.
 *
 * # Usage from JavaScript
 *
 * ```javascript
 * const text = "line0\nline1\nline2\nline3\nline4\n";
 * const textBytes = new TextEncoder().encode(text);
 *
 * // Extract lines 1-3 (rows 1 and 2, exclusive end)
 * const result = extract_lines(textBytes, 1, 3);
 *
 * if (result.error) {
 *     console.error(`Error: ${result.error}`);
 * } else {
 *     // Extract substring using character offsets
 *     const chars = Array.from(text);
 *     const extracted = chars.slice(result.start_char, result.end_char).join('');
 *     console.log(extracted);  // "line1\nline2\n"
 *     console.log(`Rows: ${result.rows_returned}, Has more: ${result.has_more}`);
 * }
 * ```
 *
 * # Returns
 *
 * Success: `{ start_char, end_char, rows_returned, has_more }`
 * Error: `{ error: "InvalidUtf8" | "EmptyInput" | "InvalidRange" }`
 * @param {Uint8Array} data
 * @param {number} start_row
 * @param {number} end_row
 * @returns {any}
 */
export function extract_lines(data, start_row, end_row) {
    const ptr0 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.extract_lines(ptr0, len0, start_row, end_row);
    return ret;
}

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_export_0.set(idx, obj);
    return idx;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_number_get = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof(obj) === 'number' ? obj : undefined;
        getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
    };
    imports.wbg.__wbindgen_number_new = function(arg0) {
        const ret = arg0;
        return ret;
    };
    imports.wbg.__wbg_get_5419cf6b954aa11d = function(arg0, arg1) {
        const ret = arg0[arg1 >>> 0];
        return ret;
    };
    imports.wbg.__wbg_length_f217bbbf7e8e4df4 = function(arg0) {
        const ret = arg0.length;
        return ret;
    };
    imports.wbg.__wbg_new_e69b5f66fda8f13c = function() {
        const ret = new Object();
        return ret;
    };
    imports.wbg.__wbg_newwithlength_310c7b54443dbe66 = function(arg0) {
        const ret = new Array(arg0 >>> 0);
        return ret;
    };
    imports.wbg.__wbg_set_425e70f7c64ac962 = function(arg0, arg1, arg2) {
        arg0[arg1 >>> 0] = arg2;
    };
    imports.wbg.__wbg_set_e864d25d9b399c9f = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = Reflect.set(arg0, arg1, arg2);
        return ret;
    }, arguments) };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = wasm.__wbindgen_export_0;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
        ;
    };

    return imports;
}

function __wbg_init_memory(imports, memory) {

}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedDataViewMemory0 = null;
    cachedUint8ArrayMemory0 = null;


    wasm.__wbindgen_start();
    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();

    __wbg_init_memory(imports);

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (typeof module_or_path === 'undefined') {
        module_or_path = new URL('jsriki_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    __wbg_init_memory(imports);

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync };
export default __wbg_init;
